import { Component, OnInit, Renderer2 } from '@angular/core';
import { LoginModel } from 'src/app/models/accounts/login.model';
import { BasePageComponent } from 'src/app/modules/core/components/bases/base-page-component';
import { RequestService } from 'src/app/modules/core/services/request.service';
import { Endpoints } from 'src/app/configs/endpoints';
import { AuthenticationService } from 'src/app/modules/core/services/authentication.service';
import { AppTokens } from 'src/app/models/authentications/access-token.model';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/modules/core/services/user.service';
import { SpinnerService } from '../../../core/services/spinner.service';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-dashboard',
    templateUrl: './login.component.html'
})
export class LoginComponent extends BasePageComponent implements OnInit {

    public model = new LoginModel();

    public disabled = false;

    public isLoad = false;

    constructor(
        public userService: UserService,
        private request: RequestService,
        private auth: AuthenticationService,
        private router: Router,
        private route: ActivatedRoute,
        private spinnerService: SpinnerService,
        private renderer: Renderer2,
        private titleService: Title,
    ) {
        super();
    }

    ngOnInit(): void {
        this.titleService.setTitle('Backend – TROFACO');
        this.spinnerService.setupShowOnBodyUntil(this.renderer, this.onDestroy$);
    }

    public async onLogin() {
        if (this.model.isModelValid()) {
            this.loading();
            try {
                const res = await this.request.formPost(Endpoints.Login, this.model.toFormData(), {retryOn401: false});
                const tokens = new AppTokens(res);
                this.auth.saveToken(tokens);
                await this.loadCurrentUser();
                let url = this.auth.getRedirectToFromQueryParams(this.route.snapshot.queryParams);
                await this.router.navigateByUrl(url);
            } catch (err) {
                this.onError();
                throw err;
            }
        }
    }

    private async loadCurrentUser() {
        await this.userService.getCurrentUserAsync();
    }

    private loading() {
        this.model.isFail = true;
        this.isLoad = true;
        this.disableForm();
    }

    private onError() {
        this.model.isFail = false;
        this.enableFrom();
    }

    private disableForm() {
        this.disabled = true;
    }

    private enableFrom() {
        this.isLoad = false;
        this.disabled = false;
    }


}
